export default __webpack_public_path__ + "static/media/img_2.1b5b03a0.png";